import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const Container = styled.div`
    width:100%;
    
  .container {
    width: 100%;
    text-align:center;
    min-height: 120vw;
    background: no-repeat  url("https://www.jlszhgh.com/download?url=shop/51660750741565576132110281443412861000110001.png");
    background-size:100vw 101vw;
    
    
  }
  .blank{
    width: 100vw;
    height: 60vw;
  }
  //.triangle{
  //  width: 90px;
  //  height: 90px;
  //  //  transform: [{ rotateZ: '45deg' }];
  //  backgroundColor: '#fff';
  //  marginTop: -35;
  //},
.content{
  margin: 0 auto;
  width: 80vw;
  height: 80vw;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 8px;
}

  .button{
   margin-top: 10vw;
  }




`
